import { HttpRequest, HttpMethod } from "./http";

class ShippingTierProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/shipping-tiers", params);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/shipping-tiers", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/shipping-tiers/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/shipping-tiers/${id}`);
    }
}

export default ShippingTierProvider;
